import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { useClassNames } from '../utils';
var ListboxOption = /*#__PURE__*/React.forwardRef(function ListboxOption(props, ref) {
  var selected = props.selected,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'dropdown-menu-item' : _props$classPrefix,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      active = props.active,
      onKeyDown = props.onKeyDown,
      rest = _objectWithoutPropertiesLoose(props, ["selected", "classPrefix", "children", "className", "disabled", "active", "onKeyDown"]);

  var _useClassNames = useClassNames(classPrefix),
      withClassPrefix = _useClassNames.withClassPrefix;

  var classes = withClassPrefix({
    active: selected,
    focus: active,
    disabled: disabled
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    role: "option",
    "aria-selected": selected || undefined,
    "aria-disabled": disabled
  }, rest, {
    className: className,
    onKeyDown: disabled ? undefined : onKeyDown
  }), /*#__PURE__*/React.createElement("span", {
    className: classes
  }, children));
});
ListboxOption.displayName = 'Listbox.Option';
export default ListboxOption;